/**
 * 使用lodash对会员数据进行排序
 * 根据type=memberTotal的transactionAmountTotal排序
 */

/**
 * 根据memberTotal的transactionAmountTotal对会员数据进行排序
 * @param {Array} data - 原始数据
 * @param {string} order - 排序方向 'ASC' | 'DESC'
 * @param {Object} _ - lodash实例
 * @returns {Array} 排序后的数据
 */
export function sortMembershipByTotalAmount(data, order, _) {
  if (!data || data.length === 0) return data;
  
  // 过滤掉membershipId=合計（全て）的行
  const filteredData = _.filter(data, item => item.membershipId !== "合計（全て）");
  const allTotalRows = _.filter(data, item => item.membershipId === "合計（全て）");
  
  // 按_membershipId分组
  const groupedData = _.groupBy(filteredData, "_membershipId");
  
  // 获取每个membership的memberTotal行的transactionAmountTotal
  const memberTotalMap = {};
  
  Object.keys(groupedData).forEach(membershipId => {
    // 查找该membership的memberTotal行
    const memberTotalRow = _.find(groupedData[membershipId], item => item.type === "memberTotal");
    if (memberTotalRow) {
      memberTotalMap[membershipId] = memberTotalRow.transactionAmountTotal || 0;
    } else {
      // 如果没有找到memberTotal行，尝试查找其他类型的行作为备选
      const anyRow = groupedData[membershipId][0];
      if (anyRow) {
        memberTotalMap[membershipId] = anyRow.transactionAmountTotal || 0;
      }
    }
  });
  
  // 按transactionAmountTotal排序membershipId
  const sortedMembershipIds = _.orderBy(
    Object.keys(memberTotalMap),
    [membershipId => memberTotalMap[membershipId]],
    [order === "ASC" ? "asc" : "desc"]
  );
  
  // 重新组织数据
  const result = [];
  
  // 按排序后的membershipId顺序添加数据
  sortedMembershipIds.forEach(membershipId => {
    const membershipData = _.filter(filteredData, item => item._membershipId === membershipId);
    result.push(...membershipData);
  });
  
  // 最后添加合計（全て）的行
  result.push(...allTotalRows);
  
  return result;
}

/**
 * 简化的排序函数，直接在Vue组件中使用
 * @param {Array} data - 原始数据
 * @param {string} order - 排序方向 'ascending' | 'descending'
 * @param {Object} _ - lodash实例
 * @returns {Array} 排序后的数据
 */
export function sortMembershipData(data, order, _) {
  const orderType = order === "ascending" ? "ASC" : "DESC";
  return sortMembershipByTotalAmount(data, orderType, _);
} 